import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Surface, Symbols } from 'recharts'
import { capitalize, startCase } from 'lodash'

const SIZE = 32
const iconSize = 14
const iconBorderColor = '#EFEFEF'

const viewBox = { x: 0, y: 0, width: SIZE, height: SIZE }
const itemStyle = {
  display: 'inline-block',
  marginRight: 10
}

const svgStyle = { display: 'inline-block', verticalAlign: 'middle', marginRight: 4 }

const renderIcon = data => {
  return (
    <Symbols
      fill={data.color}
      cx={SIZE / 2}
      cy={SIZE / 2}
      size={SIZE}
      sizeType="diameter"
      stroke={iconBorderColor}
      strokeWidth={4}
    />
  )
}

const renderItems = ({ payload, onLegendClick }) => {
  return payload.map((entry, i) => {
    const className = classNames({
      'recharts-legend-item': true,
      [`legend-item-${i}`]: true
    })

    if (entry.type === 'none') {
      return null
    }

    return (
      <li className={className} style={itemStyle} key={`legend-item-${i}`} onClick={() => onLegendClick(entry)}>
        <Surface width={iconSize} height={iconSize} viewBox={viewBox} style={svgStyle}>
          {renderIcon(entry)}
        </Surface>
        <span className="recharts-legend-item-text custom-legend-text">{capitalize(startCase(entry.value))}</span>
      </li>
    )
  })
}

/**
 * Reimplementation of {DefaultLegendContent} from the Recharts library.
 * Required as it's not currently possible to specify a stroke for Legend icons
 */
const CustomLegend = ({ payload, onLegendClick }) => {
  if (!payload || !payload.length) {
    return null
  }

  return (
    <ul
      className="recharts-default-legend"
      style={{
        padding: 0,
        margin: 0,
        textAlign: 'center'
      }}
    >
      {renderItems({ payload, onLegendClick })}
    </ul>
  )
}

CustomLegend.propTypes = {
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      id: PropTypes.any
    })
  ),
  onLegendClick: PropTypes.func.isRequired
}

export default CustomLegend
